import { WidgetsSupportMain } from '@/widgets/support';

export const PagesSupportMain = () => <WidgetsSupportMain />;
